export const ru = {
    'check-phrases-and-groups-settings':
        'Проверьте ключевые фразы и настройки групп.',
    'check-show-conditions':
        'Измените условия ретаргетинга и подбора аудитории, не ограничивайте ключевые фразы операторами, отредактируйте список ключевых фраз с учетом спроса в вашем регионе, повысьте ставку для показов в сетях. Это позволит вашим объявлениям чаще выигрывать аукцион.',
    'many-group-title':
        'Исправьте {count} групп, у которых прогнозируется мало показов',
    'one-group-title':
        'Исправьте {count} группу, у которой прогнозируется мало показов',
    'one-group-title-hint':
        'Рекомендация показывается, потому что по прогнозу у группы будет мало показов',
    'several-group-title-hint':
        'Рекомендация показывается, потому что по прогнозу у некоторых групп будет мало показов',
    'show-many-group-button': 'Посмотреть {count} групп',
    'show-one-group-button': 'Посмотреть {count} группу',
    'show-some-group-button': 'Посмотреть {count} группы',
    'simple-title':
        'Объявления группы не показываются или показываются редко. Попробуйте изменить ее настройки.',
    'some-group-title':
        'Исправьте {count} группы, у которых прогнозируется мало показов',
    'twenty-one-group-title':
        'Измените {count} группу, у которых прогнозируется мало показов'
};
